export const isJSON = (str: string): boolean => {
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
};

export const isEmptyObject = (obj: unknown) => typeof obj === 'object' && obj !== null && Object.keys(obj).length === 0;

export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
